import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=2c979b17&scoped=true&"
import script from "./Login.vue?vue&type=script&setup=true&lang=js&"
export * from "./Login.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c979b17",
  null
  
)

export default component.exports